import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

export function useCanonicalTeacherUrl(teacher) {
  const navigate = useNavigate();
  const location = useLocation();
  const teacherId = teacher?.id;
  const teacherName = teacher?.name;

  useEffect(() => {
    if (!teacherId || !String(teacherName || '').trim()) return;

    const teacherRef = { id: teacherId, name: teacherName };
    const canonicalPath = ROUTES.TEACHER_DETAIL(teacherRef);

    if (location.pathname === canonicalPath) return;

    navigate(`${canonicalPath}${location.search}${location.hash}`, {
      replace: true,
      state: location.state,
    });
  }, [teacherId, teacherName, navigate, location.pathname, location.search, location.hash, location.state]);
}
